import { useLocation, Outlet } from "react-router-dom";

import "./Layout.css";

import ContactWidget from "./ui/ContactWidget.js";
import { useIsMobile } from "../hooks/use-mobile.tsx";
import BottomNavApp from "./BottomNavApp.tsx";

import { Header } from "./Header.tsx";
import { Footer } from "./landing/Footer.tsx";

export function Layout({ children }) {
  const [isMobile] = useIsMobile();
  const { pathname, search } = useLocation();
  const params = new URLSearchParams(search);
  const view = params.get("view") ?? "form";

  const shouldHideBottomNav =
    isMobile &&
    (pathname === "/dat-hen" ||
      pathname === "/profile" ||
      pathname === "/search" ||
      pathname === "/phieu-kham-benh/view" ||
      view === "result");

  const shouldHideBFooter =
    isMobile &&
    (pathname === "/dat-hen" ||
      pathname === "/profile" ||
      pathname === "/search" ||
      pathname === "/phieu-kham-benh/view" ||
      view === "result" ||
      pathname == "/bac-si" ||
      pathname == "/phong-kham");

  const shouldHideHeader = pathname === "/dat-hen" && isMobile;

  const phoneRaw = process.env.REACT_APP_SUPPORT_PHONE ?? "";

  return (
    <div
      className={`flex flex-col 
      ${isMobile && !shouldHideBottomNav && " "}
      ${shouldHideBottomNav && isMobile ? "h-screen" : "h-fit"}`}
    >
      {/* preload */}
      <img src="/a16/tiep-don.png" alt="" style={{ display: "none" }} />
      <img src="/images/non-schedule.svg" alt="" style={{ display: "none" }} />
      <img
        src="/images/doctor-item-top-wave.svg"
        alt=""
        style={{ display: "none" }}
      />
      <img
        src="/images/connection_error.svg"
        alt=""
        style={{ display: "none" }}
      />

      {/* <NavMenu isMobile={isMobile} /> */}
      {!shouldHideBottomNav && <Header isMobile={isMobile} />}

      {/* {!isMobile && (
        <Navbar />
      )} */}

      <div
        tag="main"
        className={`relative h-full bg-sub-primary ${!shouldHideBottomNav && isMobile ? "" : ""}`}
      >
        <Outlet />
      </div>

      {!shouldHideBFooter && <Footer phoneNumber={phoneRaw} />}

      {!shouldHideBottomNav && (
        <ContactWidget
          phoneNumber={phoneRaw}
          position={isMobile ? 'left' : 'right'}
          ismobile={isMobile}
        />
      )}

      {isMobile &&
        !shouldHideBottomNav &&
        !pathname.startsWith("/phieu-kham-benh/") && <BottomNavApp />}
    </div>
  );
}
